import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagingComponent } from './messaging.component';
import { MessagingRoutingModule } from './messaging.routing.module';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { MessageComponent } from './message/message.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComposeComponent } from './compose/compose.component';
import { MailboxComponent } from './mailbox/mailbox.component';
import { NgxEditorModule } from 'ngx-editor';

@NgModule({
	imports: [
		CommonModule,
		MessagingRoutingModule,
		SharedModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		NgxEditorModule,
	],
	declarations: [MessagingComponent, MailboxComponent, MessageComponent, ComposeComponent],
	schemas: [NO_ERRORS_SCHEMA],
})
export class MessagingModule {}
